import { SUMMARY_ROWS, buildTemplateSummaryFromApi } from './templateSummary';

const Row = ({ label, value }) => (
  <div className="flex justify-between items-start gap-4 py-3 border-b border-gray-100 last:border-b-0">
    <span className="ft-sm text-gray-500 shrink-0">{label}</span>
    <span className="ft-sm text-gray-900 text-right break-words whitespace-pre-line max-w-[70%]">
      {value || '-'}
    </span>
  </div>
);

/** The job description as the company filled it, in the order of its own preview. */
const TemplateDetail = ({ template, riskyPositions }) => {
  const summary = buildTemplateSummaryFromApi(template, riskyPositions);
  return (
    <div className="flex flex-col">
      {SUMMARY_ROWS.map((row) => (
        <Row key={row.key} label={row.label} value={summary[row.key]} />
      ))}
    </div>
  );
};

export default TemplateDetail;
